import { ApiModule } from "@packages/common";
import { Module } from "@webmotors/ioc";
import { AutocompleteService } from "./autocomplete.service";

export const AutocompleteModule: Module = {
  name: "AutocompleteModule",
  modules: [ApiModule],
  providers: [AutocompleteService],
};
